export default __webpack_public_path__ + "static/media/tonight-im-yours.da175ed5.webp";